import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileCta from "@/components/layout/StickyMobileCta";
import GiveawayBanner from "@/components/giveaway/GiveawayBanner";
import GiveawayTeaserModal from "@/components/giveaway/GiveawayTeaserModal";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <GiveawayBanner />
      <Header />
      <main className="flex-1 pb-[calc(4rem+env(safe-area-inset-bottom))] lg:pb-0">{children}</main>
      <Footer />
      <StickyMobileCta />
      <GiveawayTeaserModal />
    </div>
  );
}
